import React, { useEffect, useState, useCallback, useContext } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import { alpha, styled } from "@mui/material/styles";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import PropTypes from "prop-types";
import Paper from "@mui/material/Paper";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Button from "@mui/material/Button";
import httpCommon from "src/http-common";
import { useTable, getComparator } from "src/components/table";
import { format } from "date-fns";
import Container from "@mui/material/Container";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";

import { RouterLink } from "src/routes/components";
import { useSettingsContext } from "src/components/settings";
import CustomBreadcrumbs from "src/components/custom-breadcrumbs";
import Label from "src/components/label";
import { _userList, _roles, USER_STATUS_OPTIONS } from "src/_mock";
import TableHead from "@mui/material/TableHead";
import {
  TableSortLabel,
  TextField,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import { orderBy } from "lodash";
import Iconify from "src/components/iconify";

import { paths } from "src/routes/paths";
import RejectedStatus from "./RejectedStatus";
import InProgressStatus from "./InProgressStatus";
import DfltImg from "./no-pictures.png";
import ViewIcon from "./menuIcn.jpg";
import CompleteStatus from "./CompleteStatus";
import PendingStatus from "./PendingStatus";
import CompleteToRating from "./CompleteToRating";
import LoderImg from "./Spain_loderImg.gif";
import { DatePicker } from "@mui/x-date-pickers";
import { DateContext } from "./Context/DateContext";

const columns = [
  { id: "attachment", label: "Image", minWidth: 130, width: 130 },
  { id: "wkr_mst_wr_no", label: "WR#", minWidth: 100 },
  { id: "wkr_mst_org_date", label: "WR Date", minWidth: 150 },
  { id: "wkr_mst_wr_descs", label: "WR Description ", minWidth: 50 },
  { id: "work_area_desc", label: "Work Area", minWidth: 130 },
  { id: "wkr_mst_location_desc", label: "Level", minWidth: 150 },
  { id: "ast_mst_asset_locn", label: "Location", width: 50 },
  { id: "wkr_mst_wr_status", label: "Status", minWidth: 100 },
];

const STATUS_OPTIONS = [...USER_STATUS_OPTIONS, { value: "all", label: "All" }];

const defaultFilters = {
  name: "",
  role: [],
  status: "pending",
};

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "white",
  boxShadow: 24,
  padding: 15,
  display: "flex",
  flexDirection: "column",
  borderRadius: 6,
  width: "80%",
  maxHeight: "85vh",
  overflowY: "auto",
};
const closeIconStyle = {
  position: "absolute",
  top: 10,
  right: 10,
  color: "#000",
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function WorkListView({ currentComponentVisible }) {
  const table = useTable();

  const [currentComponentVisible2, setCurrentComponentVisible] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const settings = useSettingsContext();

  const [searchInput, setSearchInput] = useState("");

  const [selectedRowID, setSelectedRowID] = useState(null);

  const [selectedRows, setSelectedRows] = useState([]);
  const [order, setOrder] = useState("asc");
  const [orderByColumn, setOrderByColumn] = useState("");

  const userId = localStorage.getItem("ww_emp_mst_empl_id");
  const site_Cd = localStorage.getItem("ww_Hsp");
  const [workReqestNumber, setWorkReqNo] = useState(null);

  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [filteredData, setFilteredData] = useState(data);

  const [filters, setFilters] = useState(defaultFilters);

  const [activeButton, setActiveButton] = useState("second");

  const [isModalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);

  const [inProgressModalOpen, setInProgressModalOpen] = useState(false);
  const [completeModalOpen, setCompleteModalOpen] = useState(false);
  const [pendingModalOpen, setPendingModalOpen] = useState(false);
  const [completeToRatModalOpen, setCompleteToRatModalOpen] = useState(false);
  const [pendingData, setpendingData] = useState([]);
  const [inProgressData, setInProgressData] = useState([]);
  const [acknowledgementData, setAcknowledgementData] = useState([]);
  const [closedData, setClosedData] = useState([]);
  const [rejecData, setRejectData] = useState([]);
  const [allData, setallData] = useState([]);
  const [tabPress, setTabPress] = useState("pending");

  const { from, setFrom, to, setTo } = useContext(DateContext);
  const [fetchByDate, setFetchByDate] = useState(false);
  const dept = localStorage.getItem("dept");

  const url = httpCommon.defaults.baseURL;
  // chdck setting mode
  useEffect(() => {
    const handleThemeOnLoad = () => {
      const storedValue = localStorage.getItem("dataDark");

      if (storedValue === "dark") {
        document.body.classList.add("custom-darkClass");
      } else {
        document.body.classList.remove("custom-darkClass");
      }
    };
    handleThemeOnLoad();
    return () => {
      document.body.classList.remove("custom-darkClass");
    };
  }, []);

  const fetchFromDay = async () => {
    try {
      const response = await httpCommon.get(
        `/get_from_to.php?site_cd=${site_Cd}`,
      );

      if (response.data.status === "SUCCESS") {
        setFrom(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // handle Date useEffect
  useEffect(() => {
    fetchFromDay();
  }, []);

  const handlSortDate = (columnId) => {
    const sortedRows = [...filteredData].sort((a, b) => {
      const dateA = new Date(a[columnId].date);
      const dateB = new Date(b[columnId].date);
      return order === "asc" ? dateA - dateB : dateB - dateA;
    });
    setOrderByColumn(columnId);
    setFilteredData(sortedRows); // Update your state with the sorted rows
    setOrder(order === "asc" ? "desc" : "asc");
  };

  const handleSort = (columnId) => {
    const isAsc = orderByColumn === columnId && order === "asc";
    const newOrder = isAsc ? "desc" : "asc";
    setOrder(newOrder);
    setOrderByColumn(columnId);
    const sortedData = orderBy(filteredData, columnId, newOrder);
    // Update your data or state with the sorted data
    setFilteredData(sortedData);
  };

  if (currentComponentVisible2) {
    document.body.classList.add("customNav");
  } else {
    document.body.classList.remove("customNav");
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const fetchUserWorkListData = async () => {
    setFilters((pre) => ({
      ...pre,
      status: 'pending',
    }));
    setFetchByDate(false);
    setIsLoading(true);
    setFilteredData([]);

    setpendingData([]);
    setInProgressData([]);
    setAcknowledgementData([]);
    setClosedData([]);
    setRejectData([]);
    setallData([]);
    setData([]);

    const today = new Date();
    const oneYearAgo = new Date(today);
    oneYearAgo.setDate(today.getDate() - 365);

    let newTo = to ? to : today;
    let newFrom = from ? from : oneYearAgo;
    newTo = format(new Date(newTo), "yyyy-MM-dd");
    newFrom = format(new Date(newFrom), "yyyy-MM-dd");

    try {
      const response = await httpCommon.get(
        `/getUserDashbordListData.php?siteCd=${site_Cd}&dept=${dept}&to=${newTo}&from=${newFrom}&requester=${userId}`,
      );
      console.log("droPPListview", response);
      if (response.data.status === "SUCCESS") {
        const uniquePendingData = response.data.data.Pending.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.RowID === item.RowID),
        );

        // Set the state with unique pendingData
        setpendingData(uniquePendingData);
        setInProgressData(response.data.data.InProgress);
        setAcknowledgementData(response.data.data.Acknowledgement);
        setClosedData(response.data.data.Closed);
        setRejectData(response.data.data.Reject);
        setallData(response.data.data.All);

        setData(response.data.data.Pending);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Get Api data
  useEffect(() => {
   

    fetchUserWorkListData(); // Call the function directly
  }, [userId, site_Cd, fetchByDate]);

  useEffect(() => {
    const filteredData2 = pendingData.filter(
      (item) => item.wkr_mst_wr_status === "W",
    );
    setFilteredData(filteredData2);
  }, [data, pendingData]);

  // New Handle Search
  const handleSearchChange = (e) => {
    const inputValue = e.target.value;
    setSearchInput(inputValue);

    if (tabPress === "inProgress") {
      // Filter the WorkReqData based on the search input

      const newFilteredResults = inProgressData.filter(
        (item) =>
          (item.wkr_mst_wr_no &&
            item.wkr_mst_wr_no
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_wr_descs &&
            item.wkr_mst_wr_descs
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assetno &&
            item.wkr_mst_assetno
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assetno_desc &&
            item.wkr_mst_assetno_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.work_area_desc &&
            item.work_area_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_location_desc &&
            item.wkr_mst_location_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assrtlocn_desc &&
            item.wkr_mst_assrtlocn_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())),
      );

      setFilteredData(newFilteredResults);
    } else if (tabPress === "pending") {
      const newFilteredResults = pendingData.filter(
        (item) =>
          (item.wkr_mst_wr_no &&
            item.wkr_mst_wr_no
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_wr_descs &&
            item.wkr_mst_wr_descs
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assetno &&
            item.wkr_mst_assetno
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assetno_desc &&
            item.wkr_mst_assetno_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.work_area_desc &&
            item.work_area_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_location_desc &&
            item.wkr_mst_location_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assrtlocn_desc &&
            item.wkr_mst_assrtlocn_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())),
      );
      setFilteredData(newFilteredResults);
    } else if (tabPress === "rejected") {
      const newFilteredResults = rejecData.filter(
        (item) =>
          (item.wkr_mst_wr_no &&
            item.wkr_mst_wr_no
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_wr_descs &&
            item.wkr_mst_wr_descs
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assetno &&
            item.wkr_mst_assetno
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assetno_desc &&
            item.wkr_mst_assetno_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.work_area_desc &&
            item.work_area_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_location_desc &&
            item.wkr_mst_location_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assrtlocn_desc &&
            item.wkr_mst_assrtlocn_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())),
      );
      setFilteredData(newFilteredResults);
    } else if (tabPress === "completeToRate") {
      const newFilteredResults = acknowledgementData.filter(
        (item) =>
          (item.wkr_mst_wr_no &&
            item.wkr_mst_wr_no
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_wr_descs &&
            item.wkr_mst_wr_descs
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assetno &&
            item.wkr_mst_assetno
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assetno_desc &&
            item.wkr_mst_assetno_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.work_area_desc &&
            item.work_area_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_location_desc &&
            item.wkr_mst_location_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assrtlocn_desc &&
            item.wkr_mst_assrtlocn_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())),
      );
      setFilteredData(newFilteredResults);
    } else if (tabPress === "complete") {
      const newFilteredResults = closedData.filter(
        (item) =>
          (item.wkr_mst_wr_no &&
            item.wkr_mst_wr_no
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_wr_descs &&
            item.wkr_mst_wr_descs
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assetno &&
            item.wkr_mst_assetno
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assetno_desc &&
            item.wkr_mst_assetno_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.work_area_desc &&
            item.work_area_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_location_desc &&
            item.wkr_mst_location_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assrtlocn_desc &&
            item.wkr_mst_assrtlocn_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())),
      );
      setFilteredData(newFilteredResults);
    } else if (tabPress === "all") {
      const newFilteredResults = allData.filter(
        (item) =>
          (item.wkr_mst_wr_no &&
            item.wkr_mst_wr_no
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_wr_descs &&
            item.wkr_mst_wr_descs
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assetno &&
            item.wkr_mst_assetno
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assetno_desc &&
            item.wkr_mst_assetno_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.work_area_desc &&
            item.work_area_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_location_desc &&
            item.wkr_mst_location_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assrtlocn_desc &&
            item.wkr_mst_assrtlocn_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())),
      );
      setFilteredData(newFilteredResults);
    } else {
      const newFilteredResults = allData.filter(
        (item) =>
          (item.wkr_mst_wr_no &&
            item.wkr_mst_wr_no
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_wr_descs &&
            item.wkr_mst_wr_descs
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assetno &&
            item.wkr_mst_assetno
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assetno_desc &&
            item.wkr_mst_assetno_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.work_area_desc &&
            item.work_area_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_location_desc &&
            item.wkr_mst_location_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())) ||
          (item.wkr_mst_assrtlocn_desc &&
            item.wkr_mst_assrtlocn_desc
              .toLowerCase()
              .includes(inputValue?.toLowerCase())),
      );
      setFilteredData(newFilteredResults);
    }
  };

  const handleClearClick = () => {
    setSearchInput("");
    setFilteredData(data);
  };
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event, mst_RowID, wkr_mst_wr_no, items) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowID(mst_RowID);
    setWorkReqNo(wkr_mst_wr_no);
    let selectedItem = [];
    if (tabPress === "pending") {
      selectedItem = pendingData.find((item) => item.mst_RowID === mst_RowID);
      setModalData(selectedItem);
      setPendingModalOpen(true);
    } else if (tabPress === "inProgress") {
      selectedItem = inProgressData.find(
        (item) => item.mst_RowID === mst_RowID,
      );
      setModalData(selectedItem);
      setInProgressModalOpen(true);
    } else if (tabPress === "rejected") {
      selectedItem = rejecData.find((item) => item.mst_RowID === mst_RowID);
      setModalData(selectedItem);
      setModalOpen(true);
    } else if (tabPress === "completeToRate") {
      selectedItem = acknowledgementData.find(
        (item) => item.mst_RowID === mst_RowID,
      );
      setModalData(selectedItem);
      setCompleteToRatModalOpen(true);
    } else if (tabPress === "complete") {
      selectedItem = closedData.find((item) => item.mst_RowID === mst_RowID);
      setModalData(selectedItem);
      setCompleteModalOpen(true);
    } else if (tabPress === "all") {
      if (items.wkr_mst_wr_status === "W") {
        selectedItem = pendingData.find((item) => item.mst_RowID === mst_RowID);
        setModalData(selectedItem);
        setPendingModalOpen(true);
      } else if (
        items.wkr_mst_wr_status === "A" &&
        items.wrk_sts_typ_cd === "OPEN"
      ) {
        selectedItem = inProgressData.find(
          (item) => item.mst_RowID === mst_RowID,
        );
        setModalData(selectedItem);
        setInProgressModalOpen(true);
      } else if (
        items.wkr_mst_wr_status === "D" &&
        items.wrk_sts_typ_cd === null
      ) {
        selectedItem = rejecData.find((item) => item.mst_RowID === mst_RowID);
        setModalData(selectedItem);
        setModalOpen(true);
      } else if (
        items.wkr_mst_wr_status === "A" &&
        items.wrk_sts_typ_cd === "COMPLETE"
      ) {
        selectedItem = closedData.find((item) => item.mst_RowID === mst_RowID);
        setModalData(selectedItem);
        setCompleteModalOpen(true);
      }
    }
  };
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedRowID(null);
  };
  const closeModalInProgress = () => {
    setInProgressModalOpen(false); // Close the modal
  };

  // Complete model close setCompleteModalOpen
  const closeModal = () => {
    setModalOpen(false); // Close the modal
  };

  // Pending model close setPendingModalOpen
  const closeModalPending = () => {
    // fetchUserWorkListData();
    setPendingModalOpen(false); // Close the modal
  };

  const closeModalComplete = () => {
    // fetchUserWorkListData();
    // setFilters(defaultFilters);
    setCompleteModalOpen(false); // Close the modal
  };

  // completeToRatModalOpen
  const closeModalCompleteTorat = () => {
    setCompleteToRatModalOpen(false); // Close the modal
  };

  const handleDelete = (row) => {
    // Implement your handleDelete logic here
    // This function will be called when the "Delete" button is clicked.
  };
  const handleFilters = useCallback(
    (name, value) => {
      table.onResetPage();
      setFilters((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    },
    [table],
  );
  const handleFilterStatus = useCallback(
    (event, newValue) => {
      handleFilters("status", newValue);
    },
    [handleFilters],
  );
  const showCurrentComponent = () => {
    setCurrentComponentVisible(false);
    setActiveButton("second");
  };

  const callSecondComponent = () => {
    setCurrentComponentVisible(true);
    setActiveButton("first");
    // You can add logic here to call the second component or navigate to it.
  };

  // Handling the Tab Data
  const handleTabClick = (tabValue) => {
    setSearchInput("");
    setTabPress(tabValue);

    if (tabValue === "inProgress") {
      const filteredArray = inProgressData.filter(
        (item) =>
          item.wkr_mst_wr_status === "A" && item.wrk_sts_typ_cd === "OPEN",
      );
      setPage(0);
      setFilteredData(filteredArray);
    } else if (tabValue === "pending") {
      const filteredArray = pendingData.filter(
        (item) =>
          item.wkr_mst_wr_status === "W" && item.wrk_sts_typ_cd !== "OPEN",
      );
      setPage(0);
      setFilteredData(filteredArray);
    } else if (tabValue === "rejected") {
      const filteredArray = rejecData.filter(
        (item) => item.wkr_mst_wr_status === "D",
      );
      setPage(0);
      setFilteredData(filteredArray);
    } else if (tabValue === "completeToRate") {
      const filteredArray = acknowledgementData.filter(
        (item) =>
          item.wkr_mst_wr_status === "A" && item.wrk_sts_typ_cd === "COMPLETE",
      );
      setPage(0);
      setFilteredData(filteredArray);
    } else if (tabValue === "complete") {
      const filteredArray = closedData.filter(
        (item) =>
          (item.wkr_mst_wr_status === "A" &&
            item.wrk_sts_typ_cd === "COMPLETE") ||
          item.wrk_sts_typ_cd === "CLOSE",
      );
      setPage(0);
      setFilteredData(filteredArray);
    } else if (tabValue === "all") {
      setPage(0);
      setFilteredData(allData);
    }
  };

  return (
    <div className="spaceTopRe">
      {isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={LoderImg}
            alt="loderImg"
            style={{ width: "80px", marginBottom: "10px" }}
          />
        </div>
      ) : null}

      <Container
        maxWidth={settings.themeStretch ? false : "lg"}
        className="spaceTop"
      >
        {/* heading */}
        <div className="spaceTopR headTable">
          <div className="year_to_view" style={{ width: "100%" }}>
            <div style={{ width: "100%" }}>
              {/* FROM */}
              <DatePicker
                className="dp"
                label="FROM"
                format="dd-MM-yyyy"
                value={new Date(from)}
                sx={{
                  "& .MuiInputBase-input": {
                    height: "30px",
                    padding: "4px",
                  },
                  "& .MuiInputBase-root": {
                    height: "100%",
                  },
                }}
                onChange={(date) => setFrom(date)}
                // maxDate={todays}
                maxDate={new Date(to)}
                renderInput={(params) => (
                  <TextField {...params} size="small" className="small_input" />
                )}
              />
            </div>

            {/* Today */}
            <div className="mt10" style={{ width: "100%" }}>
              <DatePicker
                label="TO"
                className="dp"
                format="dd-MM-yyyy"
                onChange={(date) => setTo(date)}
                value={new Date(to)}
                sx={{
                  "& .MuiInputBase-input": {
                    height: "30px",
                    padding: "4px",
                  },
                  "& .MuiInputBase-root": {
                    height: "100%",
                  },
                }}
                minDate={new Date(from)}
                renderInput={(params) => (
                  <TextField {...params} size="small" className="small_input" />
                )}
                style={{ background: "black" }}
              />
            </div>

            {/* Search button */}
            <div
              className="shadow65"
              onClick={() => {
                setFetchByDate(true);
                setFilters((pre) => ({
                  ...pre,
                  status: "pending",
                }));
              }}
            >
              <div
                style={{
                  borderRadius: "8px",
                  backgroundColor: "#405cf5e6",
                  color: "#FFFFFF",
                  height: "35px",
                  width: "35px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Iconify
                  icon="il:search"
                  width="1.2rem"
                  height="1.2rem"
                  style={{ color: "white" }}
                />
              </div>
            </div>
          </div>

          {/* serch Field */}
          <div className="searchField">
            <TextField
              variant="outlined"
              sx={{
                width: "100%",
                "& .MuiInputBase-input": {
                  height: "30px",
                  padding: "4px",
                },
                "& .MuiInputBase-root": {
                  height: "100%",
                },
              }}
              placeholder="Search..."
              value={searchInput}
              onChange={handleSearchChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Iconify icon="carbon:search" />
                  </InputAdornment>
                ),
                endAdornment: searchInput ? (
                  <InputAdornment
                    position="end"
                    onClick={handleClearClick}
                    className="serchclr_btn"
                  >
                    <Iconify icon="pajamas:clear" />
                  </InputAdornment>
                ) : null,
              }}
              style={{ width: "100%" }}
            />
          </div>

          <div
            style={{
              height: "30px",
              width: "100px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={() => {
              fetchUserWorkListData();
            }}
          >
            <Iconify icon="uil:refresh" width="25px" height="25px" />
          </div>

          <Button
            component={RouterLink}
            href={paths.dashboard.work_request.new}
            variant="contained"
            startIcon={<Iconify icon="mingcute:add-line" />}
            className="newRb AddNewButton"
          >
            New Request
          </Button>
        </div>

        {/* multiple tabs */}
        <div className="TabForDesktop spaceTop25R">
          <Grid container alignItems="center" style={{ marginBottom: "30px" }}>
            <Grid item xs={9}>
              <Tabs
                value={filters.status}
                onChange={handleFilterStatus}
                sx={{
                  px: 2.5,
                  boxShadow: (theme) =>
                    `inset 0 -2px 0 0 ${alpha(theme.palette.grey[500], 0.08)}`,
                }}
              >
                {STATUS_OPTIONS.map((tab) => (
                  <Tab
                    key={tab.value}
                    iconPosition="end"
                    value={tab.value}
                    label={tab.label}
                    onClick={() => handleTabClick(tab.value)}
                    icon={
                      <Label
                        variant={
                          ((tab.value === "all" ||
                            tab.value === filters.status) &&
                            "filled") ||
                          "soft"
                        }
                        color={
                          (tab.value === "inProgress" && "secondary") ||
                          (tab.value === "pending" && "warning") ||
                          (tab.value === "completeToRate" && "info") ||
                          (tab.value === "complete" && "success") ||
                          (tab.value === "rejected" && "error") ||
                          "default"
                        }
                      >
                        {/* Pending button */}
                        {tab.value === "pending" && pendingData.length}{" "}
                        {/* Progress button */}
                        {tab.value === "inProgress" &&
                          inProgressData.length}{" "}
                        {/* Rejected button */}
                        {tab.value === "rejected" && rejecData.length}{" "}
                        {/* Complete to rate button */}
                        {tab.value === "completeToRate" &&
                          acknowledgementData.length}{" "}
                        {/* complete to rate */}
                        {tab.value === "complete" && closedData.length}{" "}
                        {/* all buuton */}
                        {tab.value === "all" && allData.length}
                      </Label>
                    }
                    className={`customTab-${tab.value} ${
                      filters.status === tab.value ? "active" : ""
                    }`}
                  />
                ))}
              </Tabs>
            </Grid>
            <Grid item xs={3}>
              {/* Buttons on the right side */}
              <Grid
                container
                justifyContent="flex-end"
                spacing={1}
                className="tglLftRgt"
              >
                <Grid item>
                  <Tooltip title="Card View" arrow>
                    <Button
                      variant="contained"
                      style={{
                        border: "1px solid #8080808a",
                        fontSize: "12px",
                        background:
                          activeButton === "first"
                            ? "#80808029"
                            : "transparent",
                        color: "#000",
                      }}
                      onClick={showCurrentComponent}
                      component={RouterLink}
                      href={paths.dashboard.work_request.list}
                    >
                      <Iconify icon="carbon:switcher" />
                    </Button>
                  </Tooltip>
                </Grid>
                <Grid item>
                  <Tooltip title="List View" arrow>
                    <Button
                      variant="contained"
                      style={{
                        border: "1px solid #8080808a",
                        fontSize: "12px",
                        background:
                          activeButton === "second"
                            ? "#80808029"
                            : "transparent",
                        color: "#000",
                      }}
                      onClick={callSecondComponent}
                    >
                      <Iconify icon="carbon:list" />
                    </Button>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Paper>
            <TableContainer className="spaceTop25">
              <Table stickyHeader>
                {/* table Head */}
                <TableHead>
                  {/* table row start from here */}
                  <TableRow>
                    {columns.map((column) => {
                      const isColumnActive = orderByColumn === column.id;
                      const isAsc = isColumnActive && order === "asc";

                      return column.id == "wkr_mst_org_date" ? (
                        <TableCell
                          key={column.id}
                          style={{
                            minWidth: column.minWidth,
                            width: column.width,
                          }}
                        >
                          <TableSortLabel
                            active={isColumnActive}
                            direction={isColumnActive ? order : "asc"}
                            onClick={() => handlSortDate(column.id)}
                          >
                            {column.label}
                          </TableSortLabel>
                        </TableCell>
                      ) : (
                        <TableCell
                          key={column.id}
                          style={{
                            minWidth: column.minWidth,
                            width: column.width,
                          }}
                        >
                          {console.log("column_Id", column.id)}
                          <TableSortLabel
                            active={isColumnActive}
                            direction={isColumnActive ? order : "asc"}
                            onClick={() => handleSort(column.id)}
                          >
                            {column.label}
                          </TableSortLabel>
                        </TableCell>
                      );
                    })}
                    <TableCell key="empty" />
                  </TableRow>
                </TableHead>
                {/* table End */}

                <TableBody>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <TableRow key={row.id}>
                        {columns.map((column) => {
                          let cellContent = row[column.id];

                          // Table image
                          if (column.id === "attachment") {
                            return (
                              <TableCell key={column.id} valign="middle">
                                {row.attachment ? (
                                  <img
                                    src={`${url}/${row.attachment}`}
                                    alt={`userImg ${row.id}`}
                                    width="100"
                                    height="100"
                                    className="lstImgUsr"
                                  />
                                ) : (
                                  <img
                                    src={DfltImg} // Replace with the path to your demo image
                                    alt="Demo"
                                    width="100"
                                    height="100"
                                    className="lstImgUsr dm"
                                  />
                                )}
                              </TableCell>
                            );
                          }
                          // work desc
                          // if (column.id === 'wkr_mst_wr_descs' && row[column.id].length > 80) {
                          //   cellContent = `${row[column.id].substring(0, 80)}...`;
                          // } else {
                          //   cellContent = row[column.id];
                          // }
                          // wrk description

                          if (column.id === "wkr_mst_org_date") {
                            const dateObject = new Date(row[column.id].date);
                            const formattedDate = format(
                              dateObject,
                              "dd-MM-yyyy HH:mm",
                              {
                                useAdditionalDayOfYearTokens: true,
                              },
                            );
                            // const time = dateObject.toTimeString().slice(0, 5); // Get "HH:MM" from the time part

                            cellContent = `${formattedDate}`;
                          }

                          if (column.id === "wkr_mst_wr_descs") {
                            return (
                              <TableCell
                                key={column.id}
                                valign="middle"
                                className="line_clamp_3"
                              >
                                <span className="line_clamp_3">
                                  {row[column.id]}
                                </span>
                              </TableCell>
                            );
                          }

                          if (column.id === "wkr_mst_wr_status") {
                            let className = "";
                            let statusText = row[column.id];
                            console.log("id", statusText);
                            console.log("status", row.wrk_sts_typ_cd);
                            switch (true) {
                              case row[column.id] === "W":
                                className = "activeStatusList";
                                statusText = "Pending";
                                break;
                              case row[column.id] === "A" &&
                                row.wrk_sts_typ_cd === "OPEN" &&
                                tabPress === "inProgress":
                                className = "inProgressStatusList";
                                statusText = "In Progress";
                                break;
                              case row[column.id] === "D":
                                className = "rejectedStatusList";
                                statusText = "rejected";
                                break;

                              case row[column.id] === "A" &&
                                row.wrk_sts_typ_cd === "COMPLETE" &&
                                row.wkr_det_numeric1 === null &&
                                tabPress === "completeToRate":
                                className = "completeStatusList";
                                statusText = "Acknowledge";
                                break;

                              case row[column.id] === "A" &&
                                row.wrk_sts_typ_cd === "COMPLETE" &&
                                row.wkr_det_numeric1 !== null:
                                className = "completeStatus2List";
                                statusText = "Complete";
                                break;

                              case row[column.id] === "A" &&
                                row.wrk_sts_typ_cd === "CLOSE" &&
                                row.wkr_det_numeric1 === null:
                                className = "completeStatus2List";
                                statusText = "Close";
                                break;

                              case tabPress === "all":
                                if (row.wkr_mst_wr_status === "W") {
                                  className = "activeStatusList";
                                  statusText = "Pending";
                                } else if (
                                  row.wkr_mst_wr_status === "A" &&
                                  row.wrk_sts_typ_cd === "OPEN"
                                ) {
                                  className = "inProgressStatusList";
                                  statusText = "In Progress";
                                } else if (
                                  row.wkr_mst_wr_status === "A" &&
                                  row.wrk_sts_typ_cd === "COMPLETE" &&
                                  row.wkr_det_numeric1 !== null
                                ) {
                                  className = "completeStatus2List";
                                  statusText = "Complete";
                                } else {
                                  className = "completeStatusList";
                                  statusText = "Acknowledgment";
                                }

                                break;

                              default:
                                break;
                            }

                            cellContent = (
                              <span className={className}>{statusText}</span>
                            );
                          }

                          return (
                            <TableCell key={column.id}>{cellContent}</TableCell>
                          );
                        })}
                        <TableCell>
                          <Tooltip title="View" arrow placement="top-start">
                            <IconButton
                              aria-label={`Delete Row ${row.ref_RowId}`}
                              className="openVieIcn"
                              onClick={(event) => {
                                console.log("row", row);
                                handleClick(
                                  event,
                                  row.RowID,
                                  row.wkr_mst_wr_no,
                                  row,
                                );
                              }}
                            >
                              <img
                                src={ViewIcon}
                                alt="viewIcon"
                                className="lstViweIcnLs"
                              />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 15, 20]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </div>

        {/* Pending Model */}

        <div>
          <BootstrapDialog
            onClose={closeModalPending}
            aria-labelledby="customized-dialog-title"
            open={pendingModalOpen}
            PaperProps={{
              style: {
                maxWidth: "100%", // Set the desired width here
              },
            }}
          >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
              {workReqestNumber} Pending Status
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={closeModalPending}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "red",
              }}
            >
              <Iconify icon="carbon:close-outline" />
            </IconButton>
            <DialogContent dividers>
              <PendingStatus
                selectedRowID={selectedRowID}
                closeModalPending={closeModalPending}
              />
            </DialogContent>
          </BootstrapDialog>
        </div>

        {/* model InProgress Popup data */}

        <div>
          <BootstrapDialog
            onClose={closeModalInProgress}
            aria-labelledby="customized-dialog-title"
            open={inProgressModalOpen}
            PaperProps={{
              style: {
                maxWidth: "100%", // Set the desired width here
              },
            }}
          >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
              {workReqestNumber} In Progress Status
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={closeModalInProgress}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "red",
              }}
            >
              <Iconify icon="carbon:close-outline" />
            </IconButton>
            <DialogContent dividers>
              <InProgressStatus selectedRowID={selectedRowID} />
            </DialogContent>
          </BootstrapDialog>
        </div>
        {/* Complete To Reate */}

        <div>
          <BootstrapDialog
            onClose={closeModalCompleteTorat}
            aria-labelledby="customized-dialog-title"
            open={completeToRatModalOpen}
            PaperProps={{
              style: {
                maxWidth: "100%", // Set the desired width here
              },
            }}
          >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
              {workReqestNumber} Acknowledgement Status
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={closeModalCompleteTorat}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "red",
              }}
            >
              <Iconify icon="carbon:close-outline" />
            </IconButton>
            <DialogContent dividers>
              <CompleteToRating
                selectedRowID={selectedRowID}
                closeModalComplete={closeModalCompleteTorat}
              />
            </DialogContent>
          </BootstrapDialog>
        </div>

        {/* Complete Status */}

        <div>
          <BootstrapDialog
            onClose={closeModalComplete}
            aria-labelledby="customized-dialog-title"
            open={completeModalOpen}
            PaperProps={{
              style: {
                maxWidth: "100%", // Set the desired width here
              },
            }}
          >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
              {workReqestNumber} Closed Status
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={closeModalComplete}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "red",
              }}
            >
              <Iconify icon="carbon:close-outline" />
            </IconButton>
            <DialogContent dividers>
              <CompleteStatus
                selectedRowID={selectedRowID}
                closeModalComplete={closeModalComplete}
              />
            </DialogContent>
          </BootstrapDialog>
        </div>

        {/* model Rejected data */}

        <div>
          <BootstrapDialog
            onClose={closeModal}
            aria-labelledby="customized-dialog-title"
            open={isModalOpen}
            PaperProps={{
              style: {
                maxWidth: "100%", // Set the desired width here
              },
            }}
          >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
              {workReqestNumber} Rejected Status
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={closeModal}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "red",
              }}
            >
              <Iconify icon="carbon:close-outline" />
            </IconButton>
            <DialogContent dividers>
              <RejectedStatus selectedRowID={selectedRowID} />
            </DialogContent>
          </BootstrapDialog>
        </div>
      </Container>
    </div>
  );
}

WorkListView.propTypes = {
  currentComponentVisible: PropTypes.bool.isRequired, // Assuming it's a boolean
};
